module.exports = __webpack_public_path__ + "d308073b/img/print-icon.d8dbbca5.svg";